import React from "react";
import optimizeImg from "../../../assets/why-testops/optimize.jpg";
import optimizeMobileImg from "../../../assets/why-testops/optimizemobile.jpg";
import "../../css/Control.css";

const Control = () => {
  return (
    <section className="control-section">
      <h2 className="control-title text-center">
        Oversee Every Stage, Optimize Processes, Deliver Perfection
      </h2>

      {/* Image Section */}
      <div className="container text-center">
        <img
          src={optimizeImg}
          alt="Optimize"
          className="img-fluid d-none d-md-block mx-auto"
        />

        <img
          src={optimizeMobileImg}
          alt="Optimize Mobile"
          className="img-fluid d-block d-md-none mx-auto"
        />
      </div>
    </section>
  );
};

export default Control;